<template>
  <div class="left_header">
    <span class="title">帘创优家福建莆田新都汉庭店</span>

    <div class="item_wamp">
      <div class="item1">
        <p>负责人: <span>黄*霞</span></p>
        <p>本月报单数: <span>15单</span></p>
        <p>本月单笔订单金额均值: <span>5246.00元</span></p>
        <p>本月销量额累计: <span>78690.00元</span></p>
        <p>上月销售额统计: <span>64620.00元</span></p>
        <p>预存款余额: <span>323.36元</span></p>
      </div>
      <div class="item2">
        <h2>20 ~ 27 <span>℃</span></h2>
        <p>
          <span>福建莆田</span> : <span style="color:white">{{ time }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LeftHeader",
  data() {
    return {
      time: "",
    };
  },
  mounted() {
    let time = new Date();
    let houer= time.getHours();
    let minTime = time.getMinutes();
    this.time = houer + ":" + minTime
  },
};
</script>

<style lang="less" scoped>
.left_header {
  width: 100%;
  height: 100%;
  padding: 1.25rem;
  box-sizing: border-box;
  position: relative;
  .title {
    width: 80%;
    margin: 0 auto;
    position: absolute;
    top: -0.25rem;
    padding: 0 1.25rem;
    font-size: 1rem;
    text-align: center;
    left: 0;
    right: 0;
    color: white;
  }
  .item_wamp {
    width: 100%;
    height: 100%;
    padding: 0.625rem 0.625rem 0 0.0625rem;
    display: flex;
    .item1 {
      flex: 5;
      & > p {
        height: 16.6%;
        font-size: 1rem;
        color: white;
      }
    }
    .item2 {
      text-align: center;
      flex: 3;
      position: relative;
      z-index: 999;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      h2 {
        height: 2rem;
        font-size: 2rem;
        color: white;
        line-height: 2rem;
        span {
          font-size: 1rem;
          color: white;
        }
      }
      p {
        margin-top: .5rem;
        span {
          color: rgb(13, 204, 211);
          font-size: 1rem;
        }
      }
    }
  }
}
</style>